<template>
  <div>
    <!-- Header: Personal Info -->
    <!-- <div class="d-flex">
      <h4 class="mb-0">Student Information</h4>
    </div> -->

    <!-- Form: Personal Info Form -->
    <b-form class="">
      <!-- Form: Personal Info Form -->
      <b-row v-if="studentSecretInfo" class="mt-1">
        <!-- Field: Social Security -->
        <b-col cols="12" lg="3" md="6" xs="12">
          <div>
            <b-form-group label="SSN" label-for="student-ssn">
              <cleave
                id="student-ssn"
                v-model="studentSecretInfo.ssn"
                class="form-control"
                :raw="false"
                required
                :options="{ blocks: [3, 2, 4], numericOnly: true, delimiter: '-' }"
                autocomplete="off"
              />
            </b-form-group>
          </div>
        </b-col>
        <!-- Field: Date of Birth -->
        <b-col cols="12" lg="3" md="6" xs="12">
          <div>
            <b-form-group label="Date of Birth" label-for="student-dob">
              <b-form-datepicker
                class="w-100"
                id="student-dob"
                v-model="studentSecretInfo.dateOfBirth"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                locale="en"
              />
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <b-row v-else></b-row>

      <b-row class="mt-2 w-100">
        <b-col cols="12" lg="12">
          <b-button variant="primary" class="float-right" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="updateAccount">
            Save Changes
          </b-button>
          <b-button
            variant="outline-secondary"
            class="mb-1 mb-sm-0 mr-0 mr-sm-1 float-right"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            @click="$router.back()"
          >
            <feather-icon icon="ArrowLeftIcon" />
            Return
          </b-button>

          <!-- <b-form-checkbox v-model="submit.sync" class="float-right mr-5" style="margin-top: 7px" input-id="submit-sync" disabled>
            Sync
          </b-form-checkbox> -->
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { BButton, BCol, BForm, BFormDatepicker, BFormGroup, BRow } from 'bootstrap-vue';
import { ref } from '@vue/composition-api';
import store from '@/store';
import router from '@/router';
import ToastificationContent from '@core/components/toastification/ToastificationContent';
import useStudents from '../../useStudents';
import Cleave from 'vue-cleave-component';
import flatPickr from 'vue-flatpickr-component';

export default {
  components: {
    ToastificationContent,
    BFormDatepicker,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BButton,
    Cleave,
    flatPickr,
  },
  props: {
    studentData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    updateDob(value) {
      this.studentSecretInfo.dateOfBirth = value;
    },
    fetchAccount() {
      store
        .dispatch('studentStoreModule/fetchStudentProfile', {
          id: router.currentRoute.params.id,
          queryParams: { populate: 'student profile cohort', secret: true, ssn: 'visible' },
        })
        .then((response) => {
          const { data } = response;
          this.studentSecretInfo = { ...data.secret, dateOfBirth: data.dateOfBirth };
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.studentSecretInfo = undefined;
          }
        });
    },
    updateAccount() {
      store
        .dispatch('studentStoreModule/updateStudentProfile', {
          id: router.currentRoute.params.id,
          profileData: {
            secret: { ssn: this.studentSecretInfo.ssn },
            dateOfBirth: this.studentSecretInfo.dateOfBirth,
          },
        })
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Saved Changes',
              icon: 'CheckIcon',
              variant: 'success',
              text: 'You have successfully updated student secret.',
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              text: 'Something went wrong. Please try again.',
            },
          });
        });
    },
  },
  mounted() {
    this.fetchAccount();
  },
  setup() {
    const studentSecretInfo = ref(undefined);
    const ssnShow = ref(false);

    const { statusOptions } = useStudents();

    return {
      studentSecretInfo,
      statusOptions,
      ssnShow,
    };
  },
};
</script>

<style lang="scss"></style>
